import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'
import 'moment/locale/ko'
import styled from 'styled-components'

//components
import Loading from '../../components/atom/loading/Loading'
import TimePicker from '../timePicker/TimePicker'
import SubmitModal from '../modal/SubmitModal'
import ToggleBtn from '../atom/toggleBtn/ToggleBtn'
import CalendarModal from '../modal/CalendarModal'
import TimeCalendarModal from '../modal/TimeCalendarModal'
import { HeaderTab } from '../../components'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'
import StoreContext from '../../globals/StoreContext'

// utils
import colors from '../../styles/colors'
import { useAxios } from '../../utils/useAxios'

//images
import EditIcon from '../../assets/image/edit/ic-edit.svg'

// constants
const STORE_HEADER_ITEM = ['기본정보', '운영정보', '배달정보']
const STORE_HEADER_ITEM_N = ['기본정보', '운영정보']

const ManageInfo = () => {
  const { fetchData, loading, data, error } = useAxios()

  const [manageData, setManageData] = useState(null)
  const [hiddenYn, setHiddenYn] = useState()

  const [show, setShow] = useState(false) //모달창
  const [calShow, setCalShow] = useState(false) //모달창
  const [timeCalShow, setTimeCalShow] = useState(false) //모달창

  const [allDay, setAllDay] = useState('N') //모달창
  const [showAllDates, setShowAllDates] = useState(false)

  //매장 정보 조회 및 초기 매장정보
  const contextData = useContext(StoreContext)
  const { storeInfoData, getStoreInfo } = contextData || {}

  // 공통 비활성화
  const [isDropdownDisabled, setIsDropdownDisabled] = useState(false)

  //로딩
  const setLoading = loading || storeInfoData ? 'true' : 'false'

  // 시작 종료 (시간, 분) 개별 비활성화
  // 시작 시간/분
  const [isDropdownHourDisabledStart, setIsDropdownHourDisabledStart] =
    useState(false)
  const [isDropdownMinuteDisabledStart, setIsDropdownMinuteDisabledStart] =
    useState(false)

  // 종료 시간/분
  const [isDropdownHourDisabledEnd, setIsDropdownHourDisabledEnd] =
    useState(false)
  const [isDropdownMinuteDisabledEnd, setIsDropdownMinuteDisabledEnd] =
    useState(false)

  const [shopHoursStart, setShopHoursStart] = useState('')
  const [shopHoursEnd, setShopHoursEnd] = useState('')
  const [deliveryHoursStart, setDeliveryHoursStart] = useState('')
  const [deliveryHoursEnd, setDeliveryHoursEnd] = useState('')
  const [ogShopHoursStart, setOgShopHoursStart] = useState('')
  const [ogShopHoursEnd, setOgShopHoursEnd] = useState('')

  const [ogDeliveryHoursStart, setOgDeliveryHoursStart] = useState('')
  const [ogDeliveryHoursEnd, setOgDeliveryHoursEnd] = useState('')
  const [closedDay, setClosedDay] = useState('')
  const [modalTitle, setModalTitle] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [daysOff, setDaysOff] = useState([])
  const [selectedDates, setSelectedDates] = useState([])
  const [rangeDates, setRangeDates] = useState([])
  const defaultSelected = {
    to: '',
    from: '',
  }
  const [range, setRange] = useState(defaultSelected)
  const [datesToDisplay, setDatesToDisplay] = useState([])
  const [defaultTime, setDefaultTime] = useState({
    start: '',
    end: '',
  })
  const [singleCalDisplay, setSingleCalDisplay] = useState(true)
  const daysOffSetting = true

  // // 매장 조회
  // const fetchManageData = () => {
  //   fetchData(constants.API.STORES_INFO, 'GET', null)
  // }

  // 초기화
  const initState = () => {
    setManageData(null)
    setShopHoursStart('')
    setShopHoursEnd('')
    setDeliveryHoursStart('')
    setDeliveryHoursEnd('')
    setOgShopHoursStart('')
    setOgShopHoursEnd('')
    setOgDeliveryHoursStart('')
    setOgDeliveryHoursEnd('')
    setClosedDay('')
  }

  //매장정보 조회
  useEffect(() => {
    if (storeInfoData) {
      // 매장정보가 존재할 경우만
      setShopInfo()
    }
  }, [storeInfoData])

  const setShopInfo = () => {
    let resData = storeInfoData?.responseData
    // 매장 정보(배달, 해피오더, 휴무일 관련) 조회
    const {
      shopHoursStart = '',
      shopHoursEnd = '',
      orderHoursStart = '',
      orderHoursEnd = '',
      closedDay = '',
      happyorderYn = '',
      hiddenMenuEnableYn = '',
    } = resData?.storeInfo ?? {}

    setManageData(resData?.storeInfo)
    setHiddenYn(hiddenMenuEnableYn)
    setShopHoursStart(shopHoursStart)
    setShopHoursEnd(shopHoursEnd)
    setDeliveryHoursStart(orderHoursStart)
    setDeliveryHoursEnd(orderHoursEnd)
    setOgShopHoursStart(shopHoursStart)
    setOgShopHoursEnd(shopHoursEnd)
    setOgDeliveryHoursStart(orderHoursStart)
    setOgDeliveryHoursEnd(orderHoursEnd)
    setClosedDay(closedDay)

    // 로컬 스토리지 추가(해피오더 유무 변경)
    localStorage.setItem('happyorderYn', happyorderYn)
    localStorage.setItem('closedDay', closedDay)
    localStorage.setItem('shopHoursStart', shopHoursStart)
    localStorage.setItem('shopHoursEnd', shopHoursEnd)
    window.dispatchEvent(new Event('storage'))
  }

  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData
    switch (resCode) {
      // 성공
      case TYPE.API_RESPONSE.SUCCESS:
        // 업데이트(매장운영시간, 배달가능시간, 휴무일)
        if (
          resData.hasOwnProperty('updateStoreInfo') &&
          resData?.updateStoreInfo === 'Y'
        ) {
          getStoreInfo()
        }
        break

      // 실패
      case TYPE.API_RESPONSE.FAILURE:
      default:
        break
    }
  }, [data])

  // 24시간 토글 YN
  useEffect(() => {
    if (allDay == 'Y' && modalTitle == '매장운영시간') {
      setIsDropdownDisabled(true)

      // 전체 시간/분 비활성화
      // setIsDropdownHourDisabledStart(true)
      // setIsDropdownMinuteDisabledStart(true)
      // setIsDropdownHourDisabledEnd(true)
      // setIsDropdownMinuteDisabledEnd(true)

      setShopHoursStart('0000')
      setShopHoursEnd('2400')
    }
    if (allDay == 'Y' && modalTitle == '배달 가능시간') {
      setIsDropdownDisabled(true)

      // 전체 시간/분 비활성화
      // setIsDropdownHourDisabledStart(true)
      // setIsDropdownMinuteDisabledStart(true)
      // setIsDropdownHourDisabledEnd(true)
      // setIsDropdownMinuteDisabledEnd(true)

      setDeliveryHoursStart('0000')
      setDeliveryHoursEnd('2400')
    }
    if (allDay == 'N') {
      setIsDropdownDisabled(false)

      // 전체 시간/분 활성화
      // setIsDropdownHourDisabledStart(false)
      // setIsDropdownMinuteDisabledStart(false)
      // setIsDropdownHourDisabledEnd(false)
      // setIsDropdownMinuteDisabledEnd(false)
    }
  }, [allDay])

  // 시간변경 모달 꺼지면 디폴트 시간 초기화
  useEffect(() => {
    if (!show && (defaultTime.start !== '' || defaultTime.end !== '')) {
      // off 처리된 모달
      // 변경된 시간 원래대로 돌려야함
      switch (modalTitle) {
        case '매장운영시간':
          setShopHoursStart(defaultTime.start)
          setShopHoursEnd(defaultTime.end)
          break

        case '배달 가능시간':
          setDeliveryHoursStart(defaultTime.start)
          setDeliveryHoursEnd(defaultTime.end)
          break

        default:
          break
      }

      setAllDay('N')
      setDefaultTime({
        start: '',
        end: '',
      })
    }
  }, [show])

  // 시작 시간/분
  const handleStartChange = (hour, minute) => {
    // console.log('시작 hour', hour)

    // if (hour.value === '24') {
    //   setIsDropdownMinuteDisabledStart(true)
    // }
    // setIsDropdownMinuteDisabledStart(false)

    if (modalTitle == '매장운영시간') {
      setShopHoursStart(hour.value + minute.value)
      setDeliveryHoursStart(manageData ? manageData.orderHoursStart : '')
    }

    if (modalTitle == '배달 가능시간') {
      setDeliveryHoursStart(hour.value + minute.value)
      setShopHoursStart(manageData ? manageData.shopHoursStart : '')
    }
  }

  // 종료 시간/분
  const handleEndChange = (hour, minute) => {
    // console.log('종료 hour', hour)
    // if (hour.value === '24') {
    //   setIsDropdownMinuteDisabledStart(false)
    //   setIsDropdownMinuteDisabledEnd(true)
    // } else {
    //   setIsDropdownMinuteDisabledEnd(false)
    // }

    if (modalTitle === '매장운영시간') {
      setShopHoursEnd(hour.value + minute.value)
      setDeliveryHoursStart(manageData ? manageData.orderHoursStart : '')
    }

    if (modalTitle === '배달 가능시간') {
      setDeliveryHoursEnd(hour.value + minute.value)
      setShopHoursStart(manageData ? manageData.shopHoursStart : '')
    }
  }

  // timeString이 3글자로 넘어올 수 있음
  // 오전 09:00
  // 무조건 0900가 아님
  // 900인 경우 있음

  // 기존 4글자로만 고려되어 오류 발생
  function convertTimeString(timeString) {
    if (timeString !== undefined) {
      var hours =
        timeString.length === 4
          ? parseInt(timeString.substr(0, 2))
          : parseInt(timeString.substr(0, 1))
      var minutes =
        timeString.length === 4
          ? parseInt(timeString.substr(2, 2))
          : parseInt(timeString.substr(1, 2))
      // var hours = parseInt(timeString.substr(0, 2))
      // var minutes = parseInt(timeString.substr(2, 2))
      var isPM = ''
      var formattedHours = ''
      if ((hours) => 12) {
        isPM = true
        formattedHours = hours - 12
      }
      if (hours < 12) {
        isPM = false
        formattedHours = hours
      }
      if (minutes == '0') {
        minutes = '00'
      }
      var formattedMinutes = minutes

      // 오전/오후
      var timeSuffix = isPM ? '오후' : '오전'
      if (formattedHours == 12) {
        timeSuffix = '밤'
      }
      return timeSuffix + ' ' + formattedHours + ':' + formattedMinutes
    }
  }

  // API: 매장운영시간, 배달가능시간 변경
  const updateHours = () => {
    if (
      isNaN(shopHoursStart) ||
      isNaN(shopHoursEnd) ||
      isNaN(deliveryHoursStart) ||
      isNaN(deliveryHoursEnd)
    ) {
      alert('시간을 설정해주세요.')
      return false
    }

    // const newShopHoursStart =
    //   shopHoursStart === '0000' ? '2400' : shopHoursStart
    const newShopHoursEnd = shopHoursEnd === '0000' ? '2400' : shopHoursEnd

    const newDeliveryHoursEnd =
      deliveryHoursEnd === '0000' ? '2400' : deliveryHoursEnd

    if (
      deliveryHoursStart < shopHoursStart ||
      newDeliveryHoursEnd > newShopHoursEnd
    ) {
      alert('배달가능시작시간은 매장운영시작시간보다 클 수 없습니다.')
      return
    }

    // 바디
    const reqData = {
      tel: manageData ? manageData.tel : '',
      mobile: manageData ? manageData.mobile : '',
      shopHoursStart: shopHoursStart,
      shopHoursEnd: newShopHoursEnd,
      orderHoursStart: deliveryHoursStart,
      orderHoursEnd: deliveryHoursEnd,
      closedDay: manageData ? manageData.closedDay : '',
    }

    fetchData(constants.API.STORES_INFO, 'PUT', reqData)

    setShow(false)
    // setIsDropdownDisabled(false)
    setIsDropdownHourDisabledStart(false)
    setIsDropdownMinuteDisabledStart(false)
    setIsDropdownHourDisabledEnd(false)
    setIsDropdownMinuteDisabledEnd(false)
    setAllDay(false)
  }

  useEffect(() => {
    // 휴무일(있음)
    if (closedDay) {
      const datesArray = closedDay.split('∀')
      const newSelectedDates = datesArray.map(
        (dates) =>
          new Date(
            `${dates.slice(0, 4)}-${dates.slice(4, 6)}-${dates.slice(-2)}`,
          ),
      )

      setSelectedDates(newSelectedDates)
    }

    // 휴무일(없음)
    if (!closedDay) {
      setSelectedDates([])
    }
  }, [closedDay])

  function daysOffDates() {
    const allYears = []
    let years = []
    let dateList = []

    if (selectedDates.length > 0) {
      if (selectedDates.length > 20) {
        selectedDates.slice(0, 20).forEach(function (date) {
          allYears.push(new Date(date).getFullYear())
          years = [...new Set(allYears)]
          dateList = selectedDates.slice(0, 20)
        })

        return renderListOfDates(
          years,
          dateList,
          selectedDates.slice(20, selectedDates.length),
        )
      }
      if (selectedDates.length <= 20) {
        selectedDates.forEach(function (date) {
          allYears.push(new Date(date).getFullYear())
          years = [...new Set(allYears)]
          dateList = selectedDates
        })
        const mDateList = moment(dateList)

        return renderListOfDates(years, dateList)
      }
    }
  }

  function showTimeCalModal(bool, type) {
    setTimeCalShow(bool)
    if (type == 'weeklyDayOff') {
      setModalTitle('정기휴무')
    }
    if (type == 'tempClose') {
      setModalTitle('영업 임시중지')
    }
    if (type == 'vacation') {
      setModalTitle('임시휴무')
    }
  }

  function showModal(bool, type) {
    if (type == 'daysOff') {
      setModalTitle('휴무일')
      setCalShow(true)
      return
    }

    if (type == 'shopHours') {
      if (shopHoursStart !== '' && shopHoursEnd !== '') {
        // 24시간인 경우
        if (
          shopHoursStart === '0000' &&
          (shopHoursEnd === '2400' || shopHoursEnd === '0000')
        ) {
          setAllDay('Y')
        }

        setDefaultTime({
          start: shopHoursStart,
          end: shopHoursEnd,
        })
      } else {
        setDefaultTime({
          start: '',
          end: '',
        })
      }

      setModalTitle('매장운영시간')
    }
    if (type == 'delivery') {
      if (deliveryHoursStart !== '' && deliveryHoursEnd !== '') {
        // 24시간인 경우
        if (
          deliveryHoursStart === '0000' &&
          (deliveryHoursEnd === '2400' || deliveryHoursEnd === '0000')
        ) {
          setAllDay('Y')
        }

        setDefaultTime({
          start: deliveryHoursStart,
          end: deliveryHoursEnd,
        })
      } else {
        setDefaultTime({
          start: '',
          end: '',
        })
      }

      setModalTitle('배달 가능시간')
    }
    if (type == 'breakTime') {
      setModalTitle('휴게시간')
    }
    if (type == 'weeklyDayOff') {
      setModalTitle('정기휴무')
    }
    if (type == 'tempClose') {
      setModalTitle('영업 임시중지')
    }
    if (type == 'vacation') {
      setModalTitle('임시휴무')
    }

    setShow(bool)
  }

  function renderListOfDates(years, dateList, allDaysOffDates) {
    if (isNaN(dateList[0])) {
      dateList.shift()
    }
    if (dateList != null) {
      // && !isNaN(dateList)
      const jsxElements = []

      jsxElements.push(
        <DateList key={'dates'}>
          {dateList.map(function (date, index) {
            return (
              <DateButton key={index}>
                <DateText> {moment(date).format('MM/DD')}</DateText>
              </DateButton>
            )
          })}
          {showAllDates
            ? allDaysOffDates.map(function (date, index) {
                return (
                  <div key={index}>
                    <DateButton>
                      <DateText> {moment(date).format('MM/DD')}</DateText>
                    </DateButton>
                  </div>
                )
              })
            : ''}
          {allDaysOffDates != undefined ? (
            <ExtendDates onClick={() => setShowAllDates(!showAllDates)}>
              ...
            </ExtendDates>
          ) : (
            ''
          )}
        </DateList>,
      )
      // with year labeled
      // for (let i = 0; i < years.length; i++) {
      //   const year = years[i]
      //   jsxElements.push(
      //     <div className="row" key={i}>
      //       <div className="row">
      //         <YearText>{year}년 </YearText>
      //       </div>
      //       <div className="d-flex flex-wrap mb-3">
      //         {dateList.map(function (date, index) {
      //           if (year === new Date(date).getFullYear()) {
      //             return (
      //               <DateButton key={index}>
      //                 <DateText> {moment(date).format('MM/DD')}</DateText>
      //               </DateButton>
      //             )
      //           }
      //           return null
      //         })}
      //       </div>
      //     </div>,
      //   )
      // }
      return jsxElements
    }
  }

  // 휴무일 설정
  const updateDaysOff = () => {
    if (!range.to || range.to == null) {
      if (!singleCalDisplay) {
        alert('휴무일 기간을 선택 해 주세요.')
        return
      }
    }

    const daysOffCombined = datesToDisplay.concat(rangeDates)
    const dateStrings = daysOffCombined
      .map((date) => moment(date).format('YYYYMMDD'))
      .sort()
    const uniqueDateStrings = [...new Set(dateStrings)]
    let totalDaysOff = []

    for (let i = 0; i < uniqueDateStrings.length; i++) {
      totalDaysOff +=
        uniqueDateStrings.length !== i + 1
          ? `${uniqueDateStrings[i]}∀`
          : `${uniqueDateStrings[i]}`
    }

    if (totalDaysOff.length == 0) {
      totalDaysOff = ''
    }

    const reqData = {
      tel: manageData ? manageData.tel : '',
      mobile: manageData ? manageData.mobile : '',
      shopHoursStart: manageData ? manageData.shopHoursStart : '',
      shopHoursEnd: manageData ? manageData.shopHoursEnd : '',
      orderHoursStart: manageData ? manageData.orderHoursStart : '',
      orderHoursEnd: manageData ? manageData.orderHoursEnd : '',
      closedDay: Array.isArray(totalDaysOff) ? '' : totalDaysOff,
    }

    fetchData(constants.API.STORES_INFO, 'PUT', reqData)

    setCalShow(false)
    setRange({
      to: '',
      from: '',
    })
  }

  return (
    <>
      <CalendarModal
        title={modalTitle}
        show={calShow}
        handleClose={() => setCalShow(false)}
        handleSubmit={updateDaysOff}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        setSelectedDates={setSelectedDates}
        selectedDates={selectedDates}
        range={range}
        setRange={setRange}
        rangeDates={rangeDates}
        setRangeDates={setRangeDates}
        daysOffSetting={daysOffSetting}
        datesToDisplay={datesToDisplay}
        setDatesToDisplay={setDatesToDisplay}
        setSingleCalDisplay={setSingleCalDisplay}
      />

      <TimeCalendarModal
        title={modalTitle}
        show={timeCalShow}
        handleClose={() => setTimeCalShow(false)}
        handleSubmit={updateDaysOff}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        setSelectedDates={setSelectedDates}
        selectedDates={selectedDates}
        range={range}
        setRange={setRange}
        rangeDates={rangeDates}
        setRangeDates={setRangeDates}
        daysOffSetting={daysOffSetting}
        datesToDisplay={datesToDisplay}
        setDatesToDisplay={setDatesToDisplay}
      />

      {!setLoading ? (
        <Loading />
      ) : (
        <>
          {hiddenYn === 'N' ? (
            <HeaderTab
              isDesktop={true}
              headerLinks={['/storeList', '/manageStoreInfo']}
              headerItem={STORE_HEADER_ITEM_N}
              selectedItem={1}
            />
          ) : (
            <HeaderTab
              isDesktop={true}
              headerLinks={[
                '/storeList',
                '/manageStoreInfo',
                '/storeDeliveryInfo',
              ]}
              headerItem={STORE_HEADER_ITEM}
              selectedItem={1}
            />
          )}

          <ManageContainer>
            <ShopInfoWrapper>
              <Container>
                <OperatingHours>
                  <TitleWrapper>
                    <TitleText>매장운영시간</TitleText>
                    <EditIconWrapper
                      onClick={() => showModal(true, 'shopHours')}
                    >
                      <img src={EditIcon} alt="" />
                      변경
                    </EditIconWrapper>
                  </TitleWrapper>
                  <TimeDisplayWrapper>
                    <TimeLabel>시간</TimeLabel>
                    <DataText>
                      {manageData &&
                        ogShopHoursStart &&
                        ogShopHoursEnd &&
                        (ogShopHoursStart === '0000' &&
                        (ogShopHoursEnd === '2400' || ogShopHoursEnd === '0000')
                          ? '24 시간'
                          : `${ogShopHoursStart.slice(
                              0,
                              2,
                            )}:${ogShopHoursStart.slice(
                              2,
                            )} ~ ${ogShopHoursEnd.slice(
                              0,
                              2,
                            )}:${ogShopHoursEnd.slice(2)}`)}

                      {/* 나중에 개발 진행 */}
                      {/* {manageData != null ? (
                        ogShopHoursStart == '0000' &&
                        (ogShopHoursEnd == '2400' ||
                          ogShopHoursEnd == '0000') ? (
                          '24 시간'
                        ) : (
                          <>
                            {ogShopHoursStart && ogShopHoursEnd
                              ? `${ogShopHoursStart.slice(
                                  0,
                                  2,
                                )}:${ogShopHoursStart.slice(
                                  2,
                                )} ~ ${ogShopHoursEnd.slice(
                                  0,
                                  2,
                                )}:${ogShopHoursEnd.slice(2)}`
                              : '-'}
                            *원래 주석 부분 시작*
                            <span>
                              {ogShopHoursStart
                                ? moment(
                                    ogShopHoursStart.length === 4
                                      ? ogShopHoursStart
                                      : `0${ogShopHoursStart}`,
                                    'HHmm',
                                  ).format('HH:mm')
                                : `-`}
                            </span>
                            {` ~ `}
                            <span>
                              {ogShopHoursEnd
                                ? moment(
                                    ogShopHoursEnd.length === 4
                                      ? ogShopHoursEnd
                                      : `0${ogShopHoursEnd}`,
                                    'HHmm',
                                  ).format('HH:mm')
                                : `-`}
                            </span>
                            <span>{convertTimeString(ogShopHoursStart)}</span>~
                      <span>{convertTimeString(ogShopHoursEnd)}</span>
                      *원래 주석 부분 끝*
                          </>
                        )
                      ) : (
                        ''
                      )} */}
                    </DataText>
                  </TimeDisplayWrapper>
                  {/* <EditIconWrapper> */}
                  <SubmitModal
                    title={modalTitle}
                    show={show}
                    handleClose={() => setShow(false)}
                    handleSubmit={updateHours}
                  >
                    {/* <div className="m-auto d-flex flex-column gap-4"> */}
                    <ToggleButton
                      yn={allDay}
                      setYn={setAllDay}
                      id={'del'}
                      toggleText={'24hr'}
                      width={'86'}
                    />
                    <TimeSettingWrapper>
                      <LabelText>시작</LabelText>
                      <TimePicker
                        onTimeChange={handleStartChange}
                        isDropdownDisabled={isDropdownDisabled}
                        isDropdownHourDisabledStart={
                          isDropdownHourDisabledStart
                        }
                        isDropdownMinuteDisabledStart={
                          isDropdownMinuteDisabledStart
                        }
                        isDropdownHourDisabledEnd={isDropdownHourDisabledEnd}
                        isDropdownMinuteDisabledEnd={
                          isDropdownMinuteDisabledEnd
                        }
                        setIsDropdownMinuteDisabledStart={
                          setIsDropdownMinuteDisabledStart
                        }
                        setIsDropdownMinuteDisabledEnd={
                          setIsDropdownMinuteDisabledEnd
                        }
                        defaultStart={defaultTime.start}
                        type={'start'}
                      />
                    </TimeSettingWrapper>
                    <TimeSettingWrapper>
                      <LabelText>종료</LabelText>
                      <TimePicker
                        onTimeChange={handleEndChange}
                        isDropdownDisabled={isDropdownDisabled}
                        isDropdownHourDisabledStart={
                          isDropdownHourDisabledStart
                        }
                        isDropdownMinuteDisabledStart={
                          isDropdownMinuteDisabledStart
                        }
                        isDropdownHourDisabledEnd={isDropdownHourDisabledEnd}
                        isDropdownMinuteDisabledEnd={
                          isDropdownMinuteDisabledEnd
                        }
                        setIsDropdownMinuteDisabledStart={
                          setIsDropdownMinuteDisabledStart
                        }
                        setIsDropdownMinuteDisabledEnd={
                          setIsDropdownMinuteDisabledEnd
                        }
                        defaultEnd={defaultTime.end}
                        type={'end'}
                      />
                    </TimeSettingWrapper>
                    {/* </div> */}
                  </SubmitModal>
                </OperatingHours>

                <DeliveryTime>
                  <TitleWrapper>
                    <TitleText>배달가능시간</TitleText>
                    <EditIconWrapper
                      onClick={() => showModal(true, 'delivery')}
                    >
                      <img src={EditIcon} alt="" />
                      변경
                    </EditIconWrapper>
                  </TitleWrapper>
                  <TimeDisplayWrapper>
                    <TimeLabel>시간</TimeLabel>
                    <DataText>
                      {manageData != null ? (
                        ogDeliveryHoursStart == '0000' &&
                        ogDeliveryHoursEnd == '2400' ? (
                          '24 시간'
                        ) : (
                          <>
                            {ogDeliveryHoursStart && ogDeliveryHoursEnd
                              ? `${ogDeliveryHoursStart.slice(
                                  0,
                                  2,
                                )}:${ogDeliveryHoursStart.slice(
                                  2,
                                )} ~ ${ogDeliveryHoursEnd.slice(
                                  0,
                                  2,
                                )}:${ogDeliveryHoursEnd.slice(2)}`
                              : '-'}
                            {/* <span>
                              {ogDeliveryHoursStart
                                ? moment(
                                    ogDeliveryHoursStart.length === 4
                                      ? ogDeliveryHoursStart
                                      : `0${ogDeliveryHoursStart}`,
                                    'HHmm',
                                  ).format('HH:mm')
                                : `-`}
                            </span>
                            {` ~ `}
                            <span>
                              {ogDeliveryHoursEnd
                                ? moment(
                                    ogDeliveryHoursEnd.length === 4
                                      ? ogDeliveryHoursEnd
                                      : `0${ogDeliveryHoursEnd}`,
                                    'HHmm',
                                  ).format('HH:mm')
                                : `-`}
                            </span> */}
                          </>
                          // <>
                          //   <span>{convertTimeString(ogDeliveryHoursStart)}</span>~
                          //   <span>{convertTimeString(ogDeliveryHoursEnd)}</span>
                          // </>
                        )
                      ) : (
                        ''
                      )}
                    </DataText>
                  </TimeDisplayWrapper>
                  {/* modal placement */}
                </DeliveryTime>
              </Container>
              <Container>
                <DaysOff>
                  <TitleWrapper>
                    <TitleText>휴무일</TitleText>
                    <EditIconWrapper onClick={() => showModal(true, 'daysOff')}>
                      <img src={EditIcon} alt="" />
                      변경
                    </EditIconWrapper>
                  </TitleWrapper>
                  <DateListContainer>
                    {closedDay && daysOffDates()}
                  </DateListContainer>
                </DaysOff>
              </Container>
            </ShopInfoWrapper>
          </ManageContainer>
        </>
      )}
    </>
  )
}

export default ManageInfo

const ShopInfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* height: auto;
  justify-content: center;
  align-items: center; */
  max-width: 768px;
  align-self: center;

  @media ${(props) => props.theme.tablet} {
    padding: 0px;
  }
  @media ${(props) => props.theme.mobile} {
    padding: 0px;
  }
`
//left side column
const Container = styled.div`
  width: 50%;
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 800px) {
    width: 100%;
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    justify-content: center;
  }
`
//right side column
// const TempContainer = styled.div`
//   width: 50%;
//   display: flex;
//   margin-top: 20px;
//   align-items: center;
//   flex-wrap: flex;
//   @media ${(props) => props.theme.mobile} {
//     width: 100%;
//     justify-content: center;
//   }
// `
const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media ${(props) => props.theme.mobile} {
  }
`
const TimeDisplayWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  @media ${(props) => props.theme.mobile} {
  }
`
// const VacationTempContainer = styled.div`
//   align-self: flex-start;
//   width: 50%;
//   display: flex;
//   margin-top: 20px;
//   align-items: center;
//   flex-wrap: flex;
//   @media ${(props) => props.theme.mobile} {
//     width: 100%;
//     justify-content: center;
//   }
// `
const OperatingHours = styled.div`
  width: 374px;
  height: 138px;
  padding: 35px 30px;
  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};

  @media (max-width: 800px) {
    width: 100%;
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    height: 100px;
    padding: 20px 20px 20px;
  }
`
const DeliveryTime = styled.div`
  width: 374px;
  height: 138px;
  padding: 35px 30px;
  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};

  @media (max-width: 800px) {
    width: 100%;
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    height: 100px;
    padding: 20px;
  }
`
// const TempClose = styled.div`
//   width: 374px;
//   height: 296px;
//   padding: 35px 30px;
//   object-fit: contain;
//   border-radius: 15px;
//   box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
//   background-color: ${colors.W1};
//   @media ${(props) => props.theme.mobile} {
//     width: 100%;
//     height: 200px;
//     padding: 20px;
//   }
// `
const DaysOff = styled.div`
  width: 374px;
  min-height: 296px;
  padding: 33px 30px;
  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};

  @media (max-width: 800px) {
    margin-top: 20px;
    width: 100%;
  }

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    min-height: 190px;
    margin: 20px 0px 0px;
    padding: 20px;
  }
`
// const Vacation = styled.div`
//   width: 374px;
//   height: 256px;
//   padding: 35px 30px;
//   object-fit: contain;
//   border-radius: 15px;
//   box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
//   background-color: ${colors.W1};
//   @media ${(props) => props.theme.mobile} {
//     width: 320px;
//     height: 160px;
//     padding: 20px;
//   }
// `
const TitleText = styled.span`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.BK};
  @media ${(props) => props.theme.mobile} {
  }
`
const EditIconWrapper = styled.span`
  float: right;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
  color: ${colors.mainG};
  @media ${(props) => props.theme.mobile} {
  }
`
const TimeLabel = styled.span`
  font-size: 16px;
  color: ${colors.D3};
  margin-right: 20px;
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
const DataText = styled.p`
  font-size: 16px;
  color: ${colors.BK};
  flex: 1;
  /* width: 84%; */
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

// const YearText = styled.div`
//   font-size: 17px;
//   font-weight: normal;
//   font-stretch: normal;
//   font-style: normal;
//   line-height: normal;
//   letter-spacing: normal;
//   text-align: left;
//   color: ${colors.G4};
// `
const DateButton = styled.div`
  width: 69px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 7px 4px;
  border-radius: 15px;
  background-color: ${colors.mainG};
  @media ${(props) => props.theme.mobile} {
    width: 80px;
    height: 30px;
    margin: 7.5px 6px;
  }
`
const DateText = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.W1};
`
const DateList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  @media ${(props) => props.theme.mobile} {
    /* justify-content: space-around; */
  }
`
const DateListContainer = styled.div`
  padding-top: 22px;
`
const ExtendDates = styled.div`
  width: 100%;
  text-align: right;
  margin: 0px 20px 0px 0px;
`

const ToggleButton = styled(ToggleBtn)`
  align-self: end;
  margin-bottom: 20px;
`
const TimeSettingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`
const LabelText = styled.span`
  display: flex;
  /* align-items: center;
  margin: 2px 20px 2px 5px; */
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.D3};
  margin-right: 20px;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const ManageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
